const data = {
  titleSelect: 'Direcciones guardadas',
  titleCreate: 'Nueva dirección',
  titleEdit: 'Editar dirección',
  street: 'Calle*',
  streetHolder: 'Ej: León de los aldamas',
  numExt: 'Número ext.*',
  numExtHolder: 'Ej: 110',
  numInt: 'Número int.',
  numIntHolder: 'Ej: 1a',
  cp: 'Código postal*',
  cpHolder: 'Ej: 06760',
  suburb: 'Colonia*',
  suburbHolder: 'Ej: Roma sur',
  state: 'Estado*',
  stateHolder: 'Ej: CDMX',
  buttonText: 'Guardar',
};

export default data;
